import { gql } from "@apollo/client";

// Get comments for a control
export const GET_CONTROL_COMMENTS = gql`
  query GetAnnotationComments($filter: AnnotationCommentFilterInputType!, $page: Int, $limit: Int) {
    getAnnotationComments(filter: $filter, page: $page, limit: $limit) {
      statusCode
      success
      message
      totalCount
      data {
        id
        module_type
        module_id
        entity_type
        entity_id
        content
        author_id
        author_type
        author_name
        author_email
        is_internal
        parent_comment_id
        deleted_at
        created_at
        updated_at
        mentions {
          mentioned_person_id
          user_type
          name
          email
        }
        attachments {
          id
          media_id
          type
          storage_path
          mime_type
          size_bytes
          metadata
          url
          created_at
        }
      }
    }
  }
`;

// Create a new comment
export const CREATE_COMMENT = gql`
  mutation CreateAnnotationComment($input: AnnotationCommentCreateInputType!) {
    createAnnotationComment(input: $input) {
      statusCode
      success
      message
      data {
        id
        module_type
        module_id
        entity_type
        entity_id
        content
        is_internal
        parent_comment_id
        created_at
        updated_at
        mentions {
          mentioned_person_id
          user_type
          name
          email
        }
        attachments {
          id
          media_id
          type
          storage_path
          mime_type
          size_bytes
          metadata
          url
          created_at
        }
      }
    }
  }
`;

// Update a comment
export const UPDATE_COMMENT = gql`
  mutation UpdateAnnotationComment($input: [AnnotationCommentUpdateInputType]!) {
    updateAnnotationComment(input: $input) {
      statusCode
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;

// Delete is handled via update with deleted_at
export const DELETE_COMMENT = gql`
  mutation DeleteAnnotationComment($input: [AnnotationCommentUpdateInputType]!) {
    updateAnnotationComment(input: $input) {
      statusCode
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;
